import { urls } from "../constants";
import api from "./api";

const assignProduct = async ({ data }) => {
    const response = await api.post(urls.assignProduct, {
        ...data
    });
    return {
        status: response.status,
        response: response.data
    };
};
const reAssignProduct = async ({ data }) => {
    const response = await api.post(`${urls.assignProduct}/resend`, {
        ...data
    });
    return {
        status: response.status,
        response: response.data
    };
};
const doctorServices = Object.freeze({
    assignProduct,
    reAssignProduct
})

export default doctorServices;